import { Routes } from '@angular/router';
import { authGuard } from '@shared/guards/auth.guard';
import { guestGuard } from '@shared/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./shared/components/auth-manager/auth-manager.component').then(
        (m) => m.AuthManagerComponent
      ),
  },
  {
    path: '',
    loadChildren: () => import('./modules/modules.routes').then((m) => m.MODULE_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/components/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./shared/components/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent
      ),
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
